import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[appAlphasOnly]',
    standalone: false
})
export class AlphasOnlyDirective {

  constructor(private _el: ElementRef) { }

  // @HostListener('input', ['$event']) onInputChange(event) {
  //   const initalValue = this._el.nativeElement.value;
  //   this._el.nativeElement.value = initalValue.replace(/[^a-zA-Z]*/g, '');
  //   if (initalValue !== this._el.nativeElement.value) {
  //     event.stopPropagation();
  //   }
  // }

  @HostListener('keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    // Allow functional keys
    if (['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete', 'Enter'].indexOf(event.key) !== -1) {
      return;
    }

    // Check for Alt, Ctrl, or Meta (Command) key combinations (like Ctrl+A, Ctrl+C, Ctrl+V)
    if (event.ctrlKey || event.altKey || event.metaKey) {
      return;
    }

    // Regex to allow letters (including accented ones from various languages), spaces, apostrophes, and hyphens
    const regex = /^[a-zA-Z\u00C0-\u02FF\u1E00-\u1EFF\s\u002D\u2010-\u2015\u0027\u2018\u2019\u02BB\u02BC]$/;
    if (regex.test(event.key)) {
      return;
    }

    event.preventDefault();
  }

  @HostListener('input', ['$event']) onInputChange(event) {
    const initialValue = this._el.nativeElement.value;
    // Replace anything that is not a letter (including broad accent support), space, apostrophe, or hyphen
    this._el.nativeElement.value = initialValue.replace(/[^a-zA-Z\u00C0-\u02FF\u1E00-\u1EFF\s\u002D\u2010-\u2015\u0027\u2018\u2019\u02BB\u02BC]*/g, '');
    if (initialValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
  }

}
